import styled from 'styled-components'
import { skeletonAnimation } from 'src/styles'

export const Wrapper = styled.div``

Wrapper.displayName = 'Wrapper'

export const Avatar = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  ${skeletonAnimation}
`

Avatar.displayName = 'Avatar'

export const AuthorName = styled.div`
  border-radius: var(--spacer-8);
  width: 7.25rem;
  height: 1rem;
  ${skeletonAnimation}
`

AuthorName.displayName = 'AuthorName'

export const Title = styled.div`
  width: 50%;
  height: 1rem;
  flex-shrink: 0;
  border-radius: var(--spacer-8);
  ${skeletonAnimation}
`

Title.displayName = 'Title'

export const Text = styled.div`
  width: 100%;
  height: 0.5rem;
  flex-shrink: 0;
  border-radius: var(--spacer-8);
  ${skeletonAnimation}
`

Text.displayName = 'Text'

export const Counter = styled.div`
  width: 7.75rem;
  height: 1.25rem;
  flex-shrink: 0;
  border-radius: var(--spacer-8);
  ${skeletonAnimation}
`

Counter.displayName = 'Counter'

export const Reaction = styled.div`
  width: 3rem;
  height: 2rem;
  flex-shrink: 0;
  border-radius: var(--spacer-8);
  ${skeletonAnimation}
`

Reaction.displayName = 'Reaction'
